import { isDefined } from "@clipboard-health/util-ts";
import { Box } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { useChannelMetadata } from "../hooks/useChannelMetadata";

export function ChannelDescriptionBanner(): JSX.Element | null {
  const metadata = useChannelMetadata();

  const description = metadata?.description;

  if (!isDefined(description)) {
    return null;
  }

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.background.tertiary,
        borderBottom: `1px solid ${theme.palette.divider}`,
        paddingX: 5,
        paddingY: 3,
      })}
    >
      <Text
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.text.secondary,
          textAlign: "center",
        })}
      >
        {description}
      </Text>
    </Box>
  );
}
